import IComponent from "components/commons/IComponent";
import "./Printer.scoped.css";
import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import "./PanelBase.scoped.css";
import { Divider } from "@material-ui/core";
import SwitchButton from "components/commons/SwitchButton";
import * as print from "@arcgis/core/rest/print";
import PrintTemplate from "@arcgis/core/rest/support/PrintTemplate";
import PrintParameters from "@arcgis/core/rest/support/PrintParameters";
import GetArcGISToken from "utils/GetArcGISToken";
import ReactDOM from "react-dom";
import SwitchTabs from "components/commons/SwitchTabs";
import PrintSlopeReport from "utils/PrintSlopeReport";
import ZoomTo from "components/ZoomTo";
import React from "react";
import slopeNoFormat from "utils/slopeNoFormat";
import LegendLayer from "@arcgis/core/rest/support/LegendLayer.js";
import config from "config";

const mmToPx = 3.78;
// This is weird that a mm has 4.0333 px on an actual monitor
// You can check by putting an actual ruler on a monitor
// const mmToPx = 4.0333;
const PREVIEW_SIZE = {
  A2L: [488, 404],
  A2P: [405, 545],
  A3L: [350, 285],
  A3P: [285, 385],
  A4L: [230, 200],
  A4P: [200, 265],
};
const NO_INFO_BAR_FACTORS = {
  A2L: [55, 0],
  A2P: [0, 20],
  A3L: [35, 0],
  A3P: [0, 20],
  A4L: [50, 0],
  A4P: [0, 20],
};
class Printer extends IComponent {
  constructor(props) {
    super(props);
    this.mapView = props.mapView;
    this.state = {
      editingFormData: {
        name: "",
        desc: "",
      },
      printer_dropdown_select: {
        printer_dropdown_01: ["A2", "A3", "A4"],
        printer_dropdown_02: ["Landscape", "Portrait"],
        printer_dropdown_03: ["Color", "Black and white"],
        printer_dropdown_04: Array.from(
          { length: (250000 - 500) / 500 + 1 },
          (_, index) => `1:${500 + index * 500}`
        ),
        //["1:500", "1:1000", "1:2000"],
        printer_dropdown_05: ["Yes", "No"],
      },
      isWaiting: false,
      pdfUrl: undefined,
      infoBar: true,
      layout: [`${mmToPx * 230}px`, `${mmToPx * 200}px`],
      slopenos: "",
    };
    this.printTemplate = new PrintTemplate();
    this.printParameters = new PrintParameters();
    this.printParameters.template = this.printTemplate;
    this.userOptions = {
      papersize: "A4",
      orient: "Landscape",
      infobar: "Color",
      scale: `1:${this.mapView.scale}`, //"1:1000",
    };
    this.printarea = {
      A4P: [200, 265],
      A4L: [230, 200],
      A3P: [285, 385],
      A3L: [350, 285],
      A2P: [405, 560],
      A2L: [532, 406],
    };

    let component = React.createElement(ZoomTo, props);
    this.zoomToInstance = new component.type(props);
    this.zoomToInstance.props = props;
  }

  componentDidMount() {
    // console.log(this.mapView);
    // this.mapView.extent = this.calPrintExtent(
    //   this.mapView,
    //   parseInt(this.mapView.scale),
    //   this.userOptions["papersize"] +
    //     (this.userOptions["orient"] == "Landscape" ? "L" : "P")
    // );
    // this.props.mapUICallback(
    //   "updatePaperSize",
    //   this.userOptions.papersize + this.userOptions.orient === "Landscape"
    //     ? "L"
    //     : "P"
    // );
    // console.log(this.mapView.extent);
  }

  async getToken() {
    try {
      GetArcGISToken.retriveArcgisToken(GetArcGISToken.user.arcGISToken); //.then();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  toggleDisableActionBtns(value) {
    let actionBar = document.querySelector(
      ".actionBtns.spacer.EqualWidthChildren"
    );
    actionBar.classList[value ? "add" : "remove"]("disabled");
  }

  // clearCookies() {
  //   var cookies = document.cookie.split(";");

  //   for (var i = 0; i < cookies.length; i++) {
  //     var cookie = cookies[i];
  //     var eqPos = cookie.indexOf("=");
  //     var name = eqPos > -1 ? cookie.slice(0, eqPos) : cookie.trim();
  //     document.cookie =
  //       name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  //   }
  // }

  async PrintConfirmation() {
    await this.getToken();
    let url = this.$config.orginPrintSrvUrl;
    let layout =
      this.userOptions["papersize"] +
      (this.userOptions["orient"] == "Landscape" ? "_Landscape" : "_Portrait");
    let scale = this.mapView.scale; //this.userOptions["scale"].substring(2));
    console.log(scale);

    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    const user = GetArcGISToken.user.displayName;

    // let legendLayer = new LegendLayer();
    // legendLayer.layerId = // this.$config.mapList.overlay.find((i) => i.layer.visible) ||
    //   // this.props.mapView.map.layers.find((i) => i.title == "Overlays")
    //   (
    //     this.$config.mapList.overlays.find((i) => i.layer.visible) ||
    //     this.$config.mapList.layer2D.find((i) => i.layer.visible) ||
    //     this.$config.mapList.layer2D.find((i) => i.title === "SlopeInfo")
    //   )?.layer.id;

    let TWODlegendLayer = new LegendLayer();
    let OverlaylegendLayer = new LegendLayer();

    TWODlegendLayer.layerId = (
      this.$config.mapList.layer2D.find((i) => i.layer.visible) ||
      this.$config.mapList.layer2D.find((i) => i.title === "SlopeInfo")
    )?.layer.id;

    OverlaylegendLayer.layerId = this.$config.mapList.overlays.find(
      (i) => i.layer.visible
    )?.layer.id;

    this.printTemplate = new PrintTemplate({
      format: "pdf",
      exportOptions: {
        dpi:
          layout === "A3_Portrait" && scale === 1000 && this.state.infoBar
            ? 100
            : 96,
      },
      outScale: scale,
      //outScale: parseInt((this.userOptions['scale']).substring(2)),
      scalePreserved: true,
      layout: layout + (this.state.infoBar ? "" : "_NB"),
      layoutOptions: {
        titleText: this.state["editingFormData"]["name"],
        customTextElements: [
          { Division: this.state["editingFormData"]["desc"] },
          { title: this.state["editingFormData"]["name"] },
          { scale: `1:${scale}` }, //this.userOptions["scale"] },
          { PrintedBy: `(Print by ${user})` },
          { printdate: `${day}/${month}/${year}` },
          { MapSheet: "" },
        ],
        // legendLayers: [legendLayer],
        legendLayers: [TWODlegendLayer, OverlaylegendLayer],
      },
    });
    console.log(this.userOptions["scale"]);
    this.printParameters = new PrintParameters({
      view: this.mapView,
      template: this.printTemplate,
      // extraParameters: {
      //   token: GetArcGISToken.token,
      // },
    });
    this.printParameters.outSpatialReference = this.mapView.spatialReference;
    /* var preExtent = this.mapView.extent.clone();
    var preScale = this.mapView.scale;
    var printExtent = this.calPrintExtent(this.mapView, scale, layout);
    this.mapView.extent = printExtent;
    this.mapView.scale = scale;
    console.log("Map Extent for print: ", this.mapView.extent, printExtent);
    // this.mapView.scale = parseInt(this.userOptions['scale'].substring(2));*/
    print
      .execute(url, this.printParameters)
      .then((pdfUrl) => this.setState({ pdfUrl }))
      // .catch(this.printError);
      .catch((err) => {
        GetArcGISToken.user = JSON.parse(sessionStorage.getItem("user")) || {
          displayName: "Guest",
        };
        if (
          Date.now() - (GetArcGISToken.user.timestamp || 0) >
          1000 * 60 * 60 * config.sessionTimeout
        ) {
          this.props.showDialog({
            type: "error",
            isOpen: true,
            title: "Please re-log in",
            content:
              'Session expired. Please log in again. Click "OK" will redirect you to the authorize page',
            onDialogOk: () =>
              window.location.replace(this.$config.authorizePage),
            onDialogCancel: () => {},
          });
        } else {
          this.props.showDialog({
            isOpen: true,
            type: "error",
            title: "Failed to print the map",
            content: `Error occurred when trying to print the map.Please clear the drawing in map if exist. The error message: ${JSON.stringify(
              err
            )}`,
            onDialogOk: () => {},
            onDialogCancel: () => {},
          });
        }
        // this.props.showDialog({
        //   isOpen: true,
        //   type: "error",
        //   title: "Failed to print the map",
        //   content:
        //     "Error occurred when trying to print the map. Please clear the drawing in map if exist.",
        //   // jsxElement: JSON.stringify(err),
        //   onDialogOk: () => {
        //   },
        //   onDialogCancel: () => {},
        // });
      });
    /*setTimeout(() => {
      this.mapView.extent = preExtent;
      this.mapView.scale = preScale;
    }, 50);*/
    this.setState({ isWaiting: true });
    this.toggleDisableActionBtns(true);
  }

  calPrintExtent(map, scale, papersize) {
    var area = this.printarea[papersize];
    var ptCentre = map.center;
    var xoffset = (parseFloat(area[0]) * parseFloat(scale)) / 2.0 / 1000.0;
    var yoffset = (parseFloat(area[1]) * parseFloat(scale)) / 2.0 / 1000.0;
    var printExtent = map.extent.clone();
    printExtent.xmax = ptCentre.x + xoffset;
    printExtent.ymax = ptCentre.y + yoffset;
    printExtent.xmin = ptCentre.x - xoffset;
    printExtent.ymin = ptCentre.y - yoffset;
    return printExtent;
  }

  onChangeHandler(field, value, values) {
    console.log("Printer Drop down Change ", field, value, values);
    this.userOptions[field] = values[value];
    this.updatePreviewSize();
    this.forceUpdate();
  }

  updatePreviewSize() {
    let paperSize = this.userOptions.papersize;
    let oriention = this.userOptions.orient[0];
    let infobar = this.state.infoBar;
    let previewSize = PREVIEW_SIZE[paperSize + oriention];
    if (!infobar) {
      let noInfoFactors = NO_INFO_BAR_FACTORS[paperSize + oriention];
      previewSize = previewSize.concat([]);
      previewSize[0] += noInfoFactors[0];
      previewSize[1] += noInfoFactors[1];
    }
    this.setState({
      layout: [`${mmToPx * previewSize[0]}px`, `${mmToPx * previewSize[1]}px`],
    });
  }

  getPrintMapUI() {
    let {
      editingFormData,
      printer_dropdown_select,
      isWaiting,
      pdfUrl,
      layout,
    } = this.state;
    let userOptions = this.userOptions;
    let infoBar = this.state.infoBar;

    return (
      <div>
        {!isWaiting && (
          <div>
            <div className="SubPanelContent PanelContent">
              <div
                className="EqualWidthChildren"
                style={{ padding: "0px 10px 0px 10px" }}
              >
                <div>
                  <div className="padding_1">Paper Size</div>
                  <EditableDatagridCell
                    key="printer_dropdown_01"
                    cellInfo={{
                      colDef: {
                        field: "papersize",
                        dataType: "dropdown",
                        values: printer_dropdown_select.printer_dropdown_01,
                        naText: userOptions["papersize"],
                      },

                      row: "",
                      key: "printer_dropdown_01",
                    }}
                    onChange={this.onChangeHandler.bind(this)}
                  />
                </div>
                <div className="width_spacer" />
                <div>
                  <div className="padding_1">Orientation</div>
                  <EditableDatagridCell
                    key="printer_dropdown_02"
                    cellInfo={{
                      colDef: {
                        field: "orient",
                        dataType: "dropdown",
                        values: printer_dropdown_select.printer_dropdown_02,
                        naText: userOptions["orient"],
                      },

                      row: "",
                      key: "printer_dropdown_02",
                    }}
                    onChange={this.onChangeHandler.bind(this)}
                  />
                </div>
              </div>
              {/* <div className="spacer" /> */}
              <div
                className="EqualWidthChildren"
                style={{ padding: "0px 10px 0px 10px" }}
              >
                <div>
                  <div className="padding_2">Color</div>
                  <EditableDatagridCell
                    key="printer_dropdown_03"
                    cellInfo={{
                      colDef: {
                        field: "infobar",
                        dataType: "dropdown",
                        values: printer_dropdown_select.printer_dropdown_03,
                        naText: userOptions["infobar"],
                      },

                      row: "",
                      key: "printer_dropdown_03",
                    }}
                    disabled={true}
                    onChange={this.onChangeHandler.bind(this)}
                  />
                </div>
                <div className="width_spacer" />
                <div>
                  <div className="padding_2" />
                  <SwitchButton
                    label="Information Bar"
                    placeAtRight={false}
                    checked={infoBar}
                    onClick={() => {
                      infoBar = !infoBar;
                      this.setState({ infoBar: infoBar }, () =>
                        this.updatePreviewSize()
                      );
                      // console.log("swtich button");
                    }}
                  />

                  {/* <div className="padding_2">Scale</div>
                  <EditableDatagridCell
                    key="printer_dropdown_04"
                    cellInfo={{
                      colDef: {
                        field: "scale",
                        dataType: "dropdown",
                        values: printer_dropdown_select.printer_dropdown_04,
                        naText: userOptions["scale"],
                      },

                      row: "",
                      key: "printer_dropdown_04",
                    }}
                    onChange={this.onChangeHandler.bind(this)}
                  /> */}
                </div>
              </div>
            </div>
            <Divider className="divider" />
            <div className="SubPanelContent PanelContent">
              <div className="PrinterEditForm">
                <div>
                  <div>Title</div>
                  <EditableDatagridCell
                    cellInfo={{
                      colDef: {
                        field: "name",
                        dataType: "text",
                      },
                      row: editingFormData,
                    }}
                    onChange={(field, value, values) => {
                      this.setState({
                        editingFormData: {
                          ...editingFormData,
                          [field]: value,
                        },
                      });
                    }}
                  />
                </div>
                <div className="spacer" />
                <div>
                  <div>Division</div>
                  <div>
                    <EditableDatagridCell
                      cellInfo={{
                        colDef: {
                          field: "desc",
                          dataType: "text",
                          multiline: true,
                        },
                        row: editingFormData,
                      }}
                      onChange={(field, value, values) => {
                        this.setState({
                          editingFormData: {
                            ...editingFormData,
                            [field]: value,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="spacer" />
                <div>
                  <div />
                  <div className="EqualWidthChildren">
                    <div>
                      <Button
                        variant="outlined"
                        onClick={() => this.props.mapUICallback("hideAllPanel")}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div className="AlignRight">
                      <Button
                        variant="contained"
                        onClick={() => this.PrintConfirmation()}
                      >
                        Print
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isWaiting && !pdfUrl && (
          <div className="SubPanelContent PanelContent">
            <span className="icn_loading" /> Waiting for the map print to be
            complete.
          </div>
        )}
        {isWaiting && !!pdfUrl && (
          <div className="SubPanelContent PanelContent">
            <p>
              Your map is ready to download.{" "}
              <a href={pdfUrl} target="_blank">
                Click here
              </a>{" "}
              to download the map file.
            </p>
          </div>
        )}
        {ReactDOM.createPortal(
          <div
            style={{
              position: "absolute",
              top: `calc(50% - ${layout[1]} / 2)`,
              left: `calc(50% - ${layout[0]} / 2)`,
              width: layout[0],
              height: layout[1],
              opacity: "0.5",
              zIndex: "100",
              pointerEvents: "none",
              outline: "5000px solid",
            }}
          />,
          document.querySelector(".RightView")
        )}
      </div>
    );
  }

  getPrintSlopeReports() {
    return (
      <div className="SubPanelContent PanelContent">
        <div className="">
          <div>
            <div>
              Copy and paste the feature nos into the text box above. Use line
              breaks to separate feature nos. Max 20 feature nos for each batch.
            </div>
            <div className="spacer" />

            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "slopenos",
                  dataType: "text",
                  multiline: true,
                  hint: "e.g. 7SW-C/FR 577",
                },
                row: this.state,
              }}
              onChange={(field, value, values) => {
                this.setState({
                  slopenos: value,
                });
              }}
            />
          </div>
          <div className="spacer" />
          <div>
            <div />
            <div className="EqualWidthChildren">
              <div className="AlignCentre button">
                <Button
                  variant="outlined"
                  onClick={() => this.startPrintSlopeReport()}
                >
                  <span>OK</span>
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => this.setState({ slopenos: "" })}
                >
                  <span>Cancel</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  async startPrintSlopeReport() {
    console.debug(this.state.slopenos);
    let slopenos = this.state.slopenos.split("\n");

    if (slopenos.length > 20) {
      this.props.showDialog({
        type: "error",
        isOpen: true,
        title: "Batch printing slope report",
        content: (
          <div>
            Too many slope numbers are supplied, please remove some of them
            first!
          </div>
        ),
        onDialogCancel: () => {},
      });
      return;
    }

    this.props.showDialog({
      isOpen: true,
      title: "Preparing slope report",
      content: (
        <div>
          <span className="icn_loading" />
          Querying for the features...
        </div>
      ),
      onDialogCancel: () => {},
    });

    let slopeFeatures = await Promise.all(
      slopenos.map((i) => {
        i = slopeNoFormat.FeatureNo13Char(i);
        var mSlopeNoC = slopeNoFormat.FeatureNo13Char(i).replace("/CR", "/C ");
        var mSlopeNoCR = slopeNoFormat.FeatureNo13Char(i).replace("/C ", "/CR");
        return this.zoomToInstance.queryForMMS([mSlopeNoC, mSlopeNoCR]);
      })
    );

    console.debug(slopeFeatures);

    if (slopeFeatures.every((i) => i.features.length === 0)) {
      this.props.showDialog({
        type: "error",
        isOpen: true,
        title: "Batch Slope Report Printing",
        content: <div>No slope feature is found from the input!</div>,
        onDialogOk: () => {},
      });
      return;
    }

    slopeFeatures = slopeFeatures.map((i) => i.features).flat();

    let printedMapURL = [];
    for (let i = 0; i < slopeFeatures.length; i++) {
      this.props.showDialog({
        isOpen: true,
        title: "Preparing slope report",
        content: (
          <div>
            <span className="icn_loading" />
            Preparing slope report... ({i + 1} out of {slopeFeatures.length})
          </div>
        ),
        onDialogCancel: () => {},
      });
      let slope = slopeFeatures[i];
      await PrintSlopeReport(
        slope.attributes.SLOPE_NO,
        slope.geometry,
        slope.attributes.SLOPE_NO
      );
    }
    console.debug(printedMapURL);
    this.props.showDialog({
      isOpen: false,
    });
  }

  render() {
    let { isWaiting, pdfUrl } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>
            {!!pdfUrl && (
              <span
                style={{ cursor: "pointer", marginRight: "10px" }}
                className="icon_M icn_back"
                onClick={() => {
                  this.setState({ isWaiting: false, pdfUrl: undefined });
                  this.toggleDisableActionBtns(false);
                }}
              />
            )}
            Map Printing
          </span>
          <div />
          {!isWaiting && (
            <span
              className="icn_3d_Elevationprofile_close CloseButton"
              onClick={() => this.props.mapUICallback("hideAllPanel")}
            />
          )}
        </div>
        <SwitchTabs tabText={["Print Map", "Print Slope Report"]}>
          {this.getPrintMapUI()}
          {this.getPrintSlopeReports()}
        </SwitchTabs>
      </div>
    );
  }
}

export default Printer;
